export type LibraryTabKey = 'inquiryLibrary' | 'contentLibrary' | 'saved';

export type LibraryTabRoute = {
  key: LibraryTabKey;
  title: string;
};

export const LIBRARY_TAB_ROUTES: LibraryTabRoute[] = [
  { key: 'inquiryLibrary', title: 'Inquiries' },
  { key: 'contentLibrary', title: 'Content Posts' },
  { key: 'saved', title: 'Saved' },
];

/**
 * Content Library and Saved stay mounted once visited, rather than being
 * their own routed screens, so `useFocusEffect`-based view-tracking would
 * fire on every Library screen focus regardless of the active tab. Tracking
 * instead fires on the edge into a given tab, isolated here so it's testable
 * without mounting the full `Library`/`Community`/`ContentLibrary` tree.
 */
export function isLibraryTabNewlySelected(
  tabKey: LibraryTabKey,
  previousIndex: number,
  nextIndex: number
) {
  const wasOnTab = LIBRARY_TAB_ROUTES[previousIndex]?.key === tabKey;

  const isNowOnTab = LIBRARY_TAB_ROUTES[nextIndex]?.key === tabKey;

  return isNowOnTab && !wasOnTab;
}
